<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerpt0101" class="chapter" epub:type="part" id="pt01" role="doc-part">
<header id="headerpt0101">
<h1 class="pn"><span aria-label="1" class="page" id="p1" role="doc-pagebreak"></span><a class="xref" href="#/chilashvol20005#toc">Part 1</a></h1>
<h1 class="pt">The Fourteenth Amendment</h1>
</header>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-lash-vol2-0007.vue?1ff8748f